import { styled } from '@mui/material';
import { MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
`;